import * as React from "react";
import { Tabs, Tab } from "@grandvisionhq/common";
import { Heading } from "@grandvisionhq/elements";
import { Spinner, Alert } from "@grandvisionhq/iris-ui";
import { connect, withIntl, statusLoading } from "@grandvisionhq/state";
import { setSubscriptionFormIsModalOpen, setSubscriptionFormIsEditMode, resetCCCAddress, saveCCCAddress, updateCCCAddress, fetchDetail } from "../../../CCC/actions.js";
import { getCCCForm, getCCCSubscriptionDetail, getCCCSubscriptionDetailCall } from "../../../CCC/selectors.js";
import CurrentPlanContainer from "../../CurrentPlan/CCC/Detail/CurrentPlan/CurrentPlanContainer.js";
import { Delivery } from "../../Delivery/CCC/Detail/Delivery/Delivery.js";
import { Payments } from "../../Payments/CCC/Detail/Payments/Payments.js";
/* empty css               */
const hashNames = ["details", "delivery", "payments"];
class CCCDetail extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      activeTabIndex: 0
    };
    this.handleTabClick = (index) => {
      this.setState({ activeTabIndex: index });
      history.replaceState(null, "", `#${hashNames[index]}`);
    };
    this.setActiveTab = () => {
      const hash = window.location.hash.replace(/^#/, "");
      const hashIndex = hashNames.indexOf(hash);
      if (hashIndex > -1 && this.state.activeTabIndex !== hashIndex) {
        this.setState({ activeTabIndex: hashIndex });
      }
    };
  }
  componentDidMount() {
    const { cccSubscriptionId, fetchDetail: fetchDetail2 } = this.props;
    fetchDetail2({ cccSubscriptionId });
    this.setActiveTab();
  }
  componentDidUpdate() {
    this.setActiveTab();
  }
  render() {
    const {
      detail,
      detailCall,
      intl: { getLabel },
      cccForm,
      cccSubscriptionId,
      updateCCCAddress: updateCCCAddress2,
      saveCCCAddress: saveCCCAddress2,
      resetCCCAddress: resetCCCAddress2,
      setSubscriptionFormIsEditMode: setSubscriptionFormIsEditMode2,
      setSubscriptionFormIsModalOpen: setSubscriptionFormIsModalOpen2
    } = this.props;
    const { activeTabIndex } = this.state;
    const LABEL_PREFIX = "account.ccc.details";
    if (detail && detail.id === cccSubscriptionId) {
      return /* @__PURE__ */ React.createElement("div", { className: "ccc-details" }, /* @__PURE__ */ React.createElement(Heading, { variant: "small", component: "h1", className: "ccc-details__title" }, getLabel(`${LABEL_PREFIX}.title`)), Boolean(detail.custom && detail.custom.membershipId) && /* @__PURE__ */ React.createElement("p", { className: "ccc-details__membership-id" }, `${getLabel(
        `${LABEL_PREFIX}.membership.id`
      )}: ${detail.custom?.membershipId}`), /* @__PURE__ */ React.createElement("div", { className: "ccc-details__tabs" }, /* @__PURE__ */ React.createElement(Tabs, { onChange: this.handleTabClick, activeTabIndex }, /* @__PURE__ */ React.createElement(Tab, { label: getLabel(`${LABEL_PREFIX}.tabs.currentPlan`) }), /* @__PURE__ */ React.createElement(Tab, { label: getLabel(`${LABEL_PREFIX}.tabs.deliveryDetails`) }), /* @__PURE__ */ React.createElement(Tab, { label: getLabel(`${LABEL_PREFIX}.tabs.paymentDetails`) }))), /* @__PURE__ */ React.createElement("div", { className: "ccc-details__body" }, activeTabIndex === 0 && /* @__PURE__ */ React.createElement(CurrentPlanContainer, { subscription: detail, className: "ccc-details__tab" }), activeTabIndex === 1 && /* @__PURE__ */ React.createElement(
        Delivery,
        {
          cccForm,
          onChange: updateCCCAddress2,
          onCancel: resetCCCAddress2,
          onSave: saveCCCAddress2,
          onEditModeChange: setSubscriptionFormIsEditMode2,
          onModalClose: () => {
            setSubscriptionFormIsModalOpen2(false);
          },
          subscription: detail
        }
      ), activeTabIndex === 2 && /* @__PURE__ */ React.createElement(Payments, { subscription: detail, className: "ccc-payments__tab" })));
    } else if (statusLoading(detailCall)) {
      return /* @__PURE__ */ React.createElement(Spinner, { "aria-label": getLabel("common.loadingText") });
    } else {
      return /* @__PURE__ */ React.createElement(
        Alert,
        {
          variant: "error",
          title: getLabel("account.ccc.errors.general"),
          className: "alert-m-default"
        }
      );
    }
  }
}
const WrappedWithIntl = withIntl(CCCDetail);
const mapStateToProps = (state) => ({
  detailCall: getCCCSubscriptionDetailCall(state),
  detail: getCCCSubscriptionDetail(state),
  cccForm: getCCCForm(state)
});
const mapDispatchToProps = {
  fetchDetail,
  updateCCCAddress,
  saveCCCAddress,
  resetCCCAddress,
  setSubscriptionFormIsEditMode,
  setSubscriptionFormIsModalOpen
};
const CCCDetail$1 = connect(mapStateToProps, mapDispatchToProps)(WrappedWithIntl);
export {
  CCCDetail,
  CCCDetail$1 as default,
  mapDispatchToProps,
  mapStateToProps
};
//# sourceMappingURL=CCCDetail.js.map
